__turbopack_context__.v({
  "about": "item-secondary-module-scss-module__rt0R-W__about",
  "itemSecondary": "item-secondary-module-scss-module__rt0R-W__itemSecondary",
});
